export async function apiGet(path, options = {}) {
  const res = await fetch(path, {
    credentials: options.credentials || "same-origin",
  });

  const json = await res.json().catch(() => null);
  if (!json) throw new Error(`Expected JSON response from ${path}. If you are running locally, open the site through Netlify Dev on port 8888.`);
  if (!res.ok) throw new Error(json?.error || `Request failed: ${res.status}`);
  return json;
}

export async function apiPost(path, body, options = {}) {
  const res = await fetch(path, {
    method: "POST",
    credentials: options.credentials || "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });

  const json = await res.json().catch(() => null);
  if (!json) throw new Error(`Expected JSON response from ${path}. If you are running locally, open the site through Netlify Dev on port 8888.`);
  if (!res.ok) throw new Error(json?.error || `Request failed: ${res.status}`);
  return json;
}
